import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { usePolicy } from "@/components/PolicyContext";

const KEY = "hsb-cookie-consent";

export default function CookieConsent() {
  const [show, setShow] = useState(false);
  const { open } = usePolicy();

  useEffect(() => {
    const t = setTimeout(() => {
      if (!localStorage.getItem(KEY)) setShow(true);
    }, 1200);
    return () => clearTimeout(t);
  }, []);

  const decide = (value) => {
    localStorage.setItem(KEY, value);
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.5, ease: [0.19, 1, 0.22, 1] }}
          className="fixed z-[55] bottom-20 lg:bottom-5 left-3 right-3 sm:left-auto sm:right-5 sm:max-w-md"
          data-testid="cookie-consent"
        >
          <div className="bg-ivory border border-espresso/15 rounded-2xl shadow-xl p-5">
            <p className="text-espresso/75 text-sm leading-relaxed">
              Deneyiminizi iyileştirmek için çerezler kullanıyoruz. Detaylar için{" "}
              <button onClick={() => open("cerez")} className="text-gold underline underline-offset-2" data-testid="cookie-policy-link">
                Çerez Politikası
              </button>
              ’nı inceleyebilirsiniz.
            </p>
            <div className="mt-4 flex gap-3">
              <button
                onClick={() => decide("accepted")}
                data-testid="cookie-accept"
                className="flex-1 rounded-full bg-espresso py-2.5 text-ivory text-sm font-medium transition-transform hover:scale-[1.02] active:scale-95"
              >
                Kabul Et
              </button>
              <button
                onClick={() => decide("rejected")}
                data-testid="cookie-reject"
                className="flex-1 rounded-full border border-espresso/25 py-2.5 text-espresso text-sm font-medium transition-colors hover:bg-beige/60"
              >
                Reddet
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
